var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 600,
        width: 900,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { rx: "2", height: "20", width: "46", y: "3", x: "323.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "20", width: "102", y: "3", x: "395.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "742.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "794.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "848.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "689.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "65", y: "42", x: "599.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "55.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { rx: "2", height: "25", width: "46", y: "42", x: "2.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "2",
          height: "35",
          width: "892.00005",
          y: "98.45313",
          x: "2.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "2",
          height: "444",
          width: "858.00005",
          y: "150.45313",
          x: "2.5",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          rx: "2",
          height: "443.00002",
          width: "23",
          y: "150.45313",
          x: "869.5",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }